import { render, staticRenderFns } from "./LpuCardsRequestErrorDialog.vue?vue&type=template&id=e39a24e6&"
import script from "./LpuCardsRequestErrorDialog.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LpuCardsRequestErrorDialog.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e39a24e6')) {
      api.createRecord('e39a24e6', component.options)
    } else {
      api.reload('e39a24e6', component.options)
    }
    module.hot.accept("./LpuCardsRequestErrorDialog.vue?vue&type=template&id=e39a24e6&", function () {
      api.rerender('e39a24e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/diagnostika/analiz/components/LpuCard/LpuCardsRequestErrorDialog.vue"
export default component.exports